import { apiFetch, toApiResponse } from "@shared/api/api";
import { ApiResponse } from "@shared/type/ApiType";
import { showDialog } from "@widgets/CommonDialog";
import { useMemo } from "react";
import { global, globalMenu } from "@shared/libs/Global";
import { convertLoginData, getConvertedDate } from "@shared/utils/CommonUtils";

export const UseApiService = () => {
  const apiGet = async (
    url: string,
    param: any
  ): Promise<void | ApiResponse> => {
    const response = apiFetch(url, {
      method: "GET",
    });
    return response;
  };

  const initForm = async (addFormData?: any) => {
    const response = await apiPost("/v1/getDataSet", {
      id: "com_CommonMapper_06",
      params: {
        cd_menu:
          addFormData && "cd_menu" in addFormData
            ? addFormData.cd_menu
            : globalMenu.getState().activeMenuInfo.cd_menu,
        cd_module:
          addFormData && "cd_module" in addFormData
            ? addFormData.cd_module
            : globalMenu.getState().activeMenuInfo.cd_module,
        cd_firm: global.getState().userInfo.cd_firm,
        cd_user: global.getState().userInfo.cd_user,
      },
    });

    if (response.status !== "S") return response;

    const data = response.data;

    let main: any = {};
    main["cd_firm"] = global.getState().userInfo.cd_firm;

    // searchPanel 내용
    let formdata: any[];
    formdata = data[0];
    {
      formdata != null &&
        formdata.length > 0 &&
        formdata.map((col) => {
          let param: string = col.cd_param;
          let value: string = col.cd_value;
          let p: string[] = param.split(",");

          if (
            col.tp_ctrl == "SnComboTextBox" ||
            col.tp_ctrl == "SnYearWeekPicker"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = convertLoginData(v[0].trim());
              main[p[1].trim()] = convertLoginData(v[1].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnDateBox" ||
            col.tp_ctrl == "SnDateMonthBox" ||
            col.tp_ctrl == "SnDateYearBox"
          ) {
            main[col.cd_param] = getConvertedDate(value);
          } else if (
            col.tp_ctrl == "SnPeriodBox" ||
            col.tp_ctrl == "SnPeriodMonthBox" ||
            col.tp_ctrl == "SnPeriodMonthBoxPop" ||
            col.tp_ctrl == "SnYearPeriodBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = getConvertedDate(v[0].trim());
              main[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
            }
          } else if (col.tp_ctrl == "SnComboPeriodBox" ||
            col.tp_ctrl == "SnCheckPeriodBox") {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              main[p[0].trim()] = convertLoginData(v[0].trim());
              main[p[1].trim()] = getConvertedDate(v[1].trim());
              main[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              main[p[0].trim()] = "";
              main[p[1].trim()] = "";
              main[p[2].trim()] = "";
            }
          } else {
            if (
              value == "global" &&
              global.getState().userInfo.hasOwnProperty(col.cd_param)
            ) {
              main[col.cd_param] = global.getState().userInfo[col.cd_param];
            } else {
              main[col.cd_param] = value ? convertLoginData(value) : "";
            }
          }
        });
    }

    // grid 내용
    const grid =
      data[1] != null &&
      data[1].reduce((acc: any, curr: any) => {
        const { cd_grid } = curr;
        if (acc[cd_grid]) acc[cd_grid].push(curr);
        else acc[cd_grid] = [curr];
        return acc;
      }, {});

    // freeform 내용
    const form =
      data[2] != null &&
      data[2].reduce((acc: any, curr: any) => {
        const { cd_form } = curr;
        if (acc[cd_form]) acc[cd_form].push(curr);
        else acc[cd_form] = [curr];
        return acc;
      }, {});

    let freeform1ControlData: any = {};
    const freeform1 = form.freeform1;
    {
      // freeform 날짜 변환
      freeform1 != null &&
        freeform1.length > 0 &&
        freeform1.map((col: any) => {
          let param: string = col.cd_param;
          let value: string = col.cd_value;
          let p: string[] = param.split(",");

          if (
            col.tp_ctrl == "SnComboTextBox" ||
            col.tp_ctrl == "SnYearWeekPicker"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = v[1].trim();
              freeform1ControlData[p[0].trim()] = v[0].trim();
              freeform1ControlData[p[1].trim()] = v[1].trim();
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
            }
          } else if (
            col.tp_ctrl == "SnDateBox" ||
            col.tp_ctrl == "SnDateMonthBox" ||
            col.tp_ctrl == "SnDateYearBox"
          ) {
            freeform1ControlData[col.cd_param] = getConvertedDate(value);
          } else if (
            col.tp_ctrl == "SnPeriodBox" ||
            col.tp_ctrl == "SnPeriodMonthBox" ||
            col.tp_ctrl == "SnPeriodMonthBoxPop" ||
            col.tp_ctrl == "SnYearPeriodBox"
          ) {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = getConvertedDate(v[0].trim());
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              freeform1ControlData[p[0].trim()] = getConvertedDate(v[0].trim());
              freeform1ControlData[p[1].trim()] = getConvertedDate(v[1].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
            }
          } else if (col.tp_ctrl == "SnComboPeriodBox" ||
            col.tp_ctrl == "SnCheckPeriodBox") {
            if (value && value.length >= 1) {
              let v: string[] = value.split(",");
              col[p[0].trim()] = v[0].trim();
              col[p[1].trim()] = getConvertedDate(v[1].trim());
              col[p[2].trim()] = getConvertedDate(v[2].trim());
              freeform1ControlData[p[0].trim()] = v[0].trim();
              freeform1ControlData[p[1].trim()] = getConvertedDate(v[1].trim());
              freeform1ControlData[p[2].trim()] = getConvertedDate(v[2].trim());
            } else {
              col[p[0].trim()] = "";
              col[p[1].trim()] = "";
              col[p[2].trim()] = "";
              freeform1ControlData[p[0].trim()] = "";
              freeform1ControlData[p[1].trim()] = "";
              freeform1ControlData[p[2].trim()] = "";
            }
          } else {
            freeform1ControlData[col.cd_param] = value
              ? convertLoginData(value)
              : "";
          }
        });
    }
    form.freeform1 = freeform1;
    form.freeform1ControlData = freeform1ControlData;

    let rtn = {
      formData: main,
      formControlData: data[0],
      grid: grid,
      form: form,
    };
    return rtn;
  };

  /**
   * 공통 post api 호출
   * - callback을 넘기면 공통 에러 메시지는 실행되지 않으며 호출한 쪽에서 성공/실패를 제어할 수 있음.
   * @param url
   * @param param
   * @param callback
   *
   * ex) callback 사용
   * apiPost('/system/menus', {}, (response) => {
   *   if (response.code === 200) console.log('success');
   *   else console.log('error');
   * });
   */
  const apiPost = async <T = any>(
    url: string,
    param?: any,
    callback?: (resp: ApiResponse<T>) => void | Promise<void>
  ): Promise<ApiResponse<T>> => {
    try {
      const response = await apiFetch(url, {
        method: "POST",
        body: param ?? {},
        headers: {
          "X-TENANT-ID": global.getState().userInfo.tenant_id || "DEFAULT",
        },
      });
      if (callback) await callback(response);
      return response;
    } catch (error) {
      const response = toApiResponse(error);

      if (callback) {
        await callback(response);
      } else {
        switch (response.status) {
          case "W":
            await showDialog("warning", response.message);
            break;
          case "F":
            await showDialog("alter", response.message);
            break;
          case "E":
            await showDialog("error", response.message);
            break;
        }
      }

      return response;
    }
  };

  return useMemo(
    () => ({
      apiGet,
      apiPost,
      initForm,
    }),
    [apiGet, apiPost, initForm]
  );
};
